
// import React from "react";
// import { Outlet } from "react-router-dom";
// import Navbar from "./Navbar";
// import Sidebar from "./Sidebar";


// const MainLayout = () => {
 
//   return (
//     <div>
//        <div>
//         <Navbar/>
//         <Sidebar />

//         <div className="">
//           <Outlet />
//         </div>

//       </div>
//        {/* FOOTER */}
//       <footer
//         className="text-center py-3 px-2 mt-3"
//         style={{
//           background: "#111827",
//           color: "#fff",
//           fontSize: "14px"
//         }}
//       >

//         <div className="container">

//           <div className="d-flex flex-column flex-md-row justify-content-between align-items-center gap-2">

//             {/* LEFT */}
//             <div>
//               © {new Date().getFullYear()} Pothy's Swarna Mahal
//             </div>

//             {/* <div>
//               Employee Portal
//             </div>

//             <div>
//               Made with ❤️
//             </div> */}

//           </div>

//         </div>

//       </footer> 
      
//     </div>
//   );
// };

// export default MainLayout;


import React from "react";
import { Outlet } from "react-router-dom";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";

const MainLayout = () => {

  return (

    <div className="d-flex flex-column min-vh-100">

      {/* HEADER */}
      <Navbar />

      {/* SIDEBAR + CONTENT */}
      <div className="d-flex flex-grow-1">

        <Sidebar />

        {/* PAGE CONTENT */}
        <main
          className="flex-grow-1"
          style={{
            overflowX: "hidden",
            paddingBottom: "20px",
            paddingTop:"60px"
          }}
        >
          <Outlet />
        </main>

      </div>

      {/* FOOTER */}
      <footer
        className="text-center py-3 px-2"
        style={{
          background: "#aaa",
          color: "#000",
          fontWeight:700,
          fontSize: "12px"
        }}
      >

        <div className="container">

          <div className="d-flex flex-column flex-md-row justify-content-center align-items-center gap-2">

            {/* LEFT */}
            <div>
              © {new Date().getFullYear()} Pothy's Swarna Mahal Pvt Ltd
            </div>

          </div>

        </div>

      </footer>

    </div>
  );
};

export default MainLayout;